import ClipCross from './ClipCross.vue';
export default ClipCross;
